<ng-container *ngFor="let notification of notifications; trackBy: trackByNotification">
  <ng-template #notification></ng-template>
</ng-container>
